import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import FindInvoiceNumberInput from "./FindInvoiceNumberInput";

const FindCommercialDocumentFeaturesComponent = () => {
  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Find Invoice / Credit Note Info
        </Typography>

        <FindInvoiceNumberInput />
      </Grid>
    </SanitizedGrid>
  );
};

export default FindCommercialDocumentFeaturesComponent;
